var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_350_425)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0002 35.75C28.7302 35.75 28.4802 35.6 28.3502 35.37C28.2202 35.14 28.2202 34.85 28.3602 34.62L29.4102 32.87C29.6202 32.51 30.0802 32.4 30.4402 32.61C30.8002 32.82 30.9102 33.28 30.7002 33.64L30.4302 34.09C33.1902 33.44 35.2602 30.96 35.2602 28C35.2602 27.59 35.6002 27.25 36.0102 27.25C36.4202 27.25 36.7602 27.59 36.7602 28C36.7502 32.27 33.2702 35.75 29.0002 35.75Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75C15.59 22.75 15.25 22.41 15.25 22C15.25 17.73 18.73 14.25 23 14.25C23.27 14.25 23.52 14.4 23.65 14.63C23.78 14.86 23.78 15.15 23.64 15.38L22.59 17.13C22.38 17.49 21.92 17.6 21.56 17.39C21.2 17.18 21.09 16.72 21.3 16.36L21.57 15.91C18.81 16.56 16.74 19.04 16.74 22C16.75 22.41 16.41 22.75 16 22.75Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6799 20.4999C31.5499 20.4999 31.4199 20.4699 31.2999 20.3999L27.3299 18.0998C26.9699 17.8898 26.8499 17.4299 27.0599 17.0699C27.2699 16.7099 27.7299 16.5899 28.0799 16.7999L31.6799 18.8799L35.2499 16.8099C35.6099 16.5999 36.0699 16.7299 36.2699 17.0799C36.4799 17.4399 36.3499 17.8999 35.9999 18.1099L32.0499 20.3899C31.9399 20.4599 31.8099 20.4999 31.6799 20.4999Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6802 24.5698C31.2702 24.5698 30.9302 24.2298 30.9302 23.8198V19.7397C30.9302 19.3297 31.2702 18.9897 31.6802 18.9897C32.0902 18.9897 32.4302 19.3297 32.4302 19.7397V23.8198C32.4302 24.2398 32.0902 24.5698 31.6802 24.5698Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6799 24.7499C31.2199 24.7499 30.7499 24.6499 30.3799 24.4399L27.9799 23.1099C27.1999 22.6799 26.6099 21.67 26.6099 20.78V18.2399C26.6099 17.3399 27.1999 16.34 27.9899 15.9L30.3899 14.57C31.1299 14.16 32.2399 14.16 32.9899 14.57L35.3899 15.9C36.1699 16.33 36.7599 17.3399 36.7599 18.2299V20.77C36.7599 21.67 36.1699 22.6699 35.3899 23.0999L32.9899 24.4299C32.5999 24.6499 32.1399 24.7499 31.6799 24.7499ZM31.1099 15.8699L28.7099 17.2C28.4099 17.37 28.1099 17.8799 28.1099 18.2199V20.76C28.1099 21.11 28.4099 21.62 28.7099 21.78L31.1099 23.1199C31.3999 23.2799 31.9599 23.2799 32.2499 23.1199L34.6499 21.7899C34.9499 21.6199 35.2499 21.11 35.2499 20.77V18.2299C35.2499 17.8799 34.9499 17.37 34.6499 17.21L32.2499 15.8799C31.9599 15.7099 31.3899 15.7099 31.1099 15.8699Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 31.4999C20.19 31.4999 20.06 31.4699 19.94 31.3999L15.97 29.0998C15.61 28.8898 15.49 28.4299 15.7 28.0699C15.91 27.7099 16.37 27.5899 16.72 27.7999L20.32 29.8799L23.89 27.8099C24.25 27.5999 24.71 27.7299 24.91 28.0799C25.12 28.4399 24.99 28.8999 24.64 29.1099L20.69 31.3899C20.58 31.4599 20.45 31.4999 20.32 31.4999Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3198 35.5698C19.9098 35.5698 19.5698 35.2298 19.5698 34.8198V30.7397C19.5698 30.3297 19.9098 29.9897 20.3198 29.9897C20.7298 29.9897 21.0698 30.3297 21.0698 30.7397V34.8198C21.0698 35.2398 20.7398 35.5698 20.3198 35.5698Z",
    fill: "#394455"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.32 35.7499C19.86 35.7499 19.39 35.6499 19.02 35.4399L16.62 34.1099C15.84 33.6799 15.25 32.67 15.25 31.78V29.2399C15.25 28.3399 15.84 27.3399 16.62 26.9099L19.02 25.58C19.76 25.17 20.88 25.17 21.62 25.58L24.02 26.9099C24.8 27.3399 25.39 28.3499 25.39 29.2399V31.78C25.39 32.68 24.8 33.6799 24.01 34.1199L21.61 35.45C21.25 35.65 20.79 35.7499 20.32 35.7499ZM19.75 26.8699L17.35 28.2C17.05 28.37 16.75 28.8799 16.75 29.2199V31.76C16.75 32.11 17.05 32.62 17.35 32.78L19.75 34.1099C20.04 34.2699 20.6 34.2699 20.89 34.1099L23.29 32.78C23.59 32.61 23.89 32.1 23.89 31.76V29.2199C23.89 28.8699 23.59 28.36 23.29 28.2L20.89 26.8599C20.61 26.7099 20.04 26.7099 19.75 26.8699Z",
    fill: "#394455"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_350_425",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_350_425"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_350_425",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.0ab142883e52963d768f4dd9abcd76b7.svg";
export { ForwardRef as ReactComponent };